import React from 'react'

import { Col, Row } from '_zari/core'

import * as Sections from './sections'

const VentasReportes = () => {
  return (
    <Row>
      <Col md={6}>
        <Sections.EstandarSection />
      </Col>
    </Row>
  )
}

export default React.memo(VentasReportes)
